import { Navigate, Outlet, useLocation } from 'react-router';
import { useAppStateContext } from '../hooks';

// For authenticated and device-registered users (main app routes)
export const PlayerProtectedRoute = () => {
  const { appState } = useAppStateContext();
  const { pathname } = useLocation();

  const isValidatePlayer = Boolean(appState?.tid);
  const isDeviceRegistered =
    Boolean(appState?.deviceInfo?.accessToken) && isValidatePlayer;

  const isUtilityRoute = ['/reset', '/info'].includes(pathname);

  if ((!isDeviceRegistered || !isValidatePlayer) && !isUtilityRoute) {
    const navigateTo = isValidatePlayer ? '/device/config' : '/auth/login';
    return <Navigate to={navigateTo} replace />;
  }

  // Only allow access to player routes when fully authenticated
  return <Outlet />;
};
